import React from "react";
import Meta from "./../components/Meta";
import HeroSection from "./../components/HeroSection";
import PricingSection from "./../components/PricingSection";
import PricingSection4 from "./../components/PricingSection4";
import NewsletterSection from "./../components/NewsletterSection";
import Section2 from "../components/Section2";

function AppsPage(props) {
  return (
    <>
    <br>
    </br>
      <Meta title="Apps" />
      <HeroSection
        color="white"
        size="medium"
        backgroundImage="/halftone-1696542371.svg"
        backgroundImageOpacity={1}
        title="PDS Apps"
        subtitle="Use our customizable demo/template applications to accelerate your company’s integration with PDS."
        image="pds-portfolio-loading-animation.gif"
        buttonText="Get Started"
        buttonColor="primary"
        buttonInverted={false}
        buttonPath="/contact"
      />
      <Section2
        color="secondary"
        size="normal"
        backgroundImage=""
        backgroundImageOpacity=""
        title="Customizable tools for enterprise"
        subtitle="Built on the PDS platform, our apps provide solutions for managing digital IP marketing, data brokerage and AI/LLM integration."
        className="has-text-centered"
      />
      <PricingSection
        color="white"
        size="medium"
        backgroundImage="/halftone-1696560535.svg"
        backgroundImageOpacity={1}
        title="PDS AppSuite"
        subtitle="We offer a collection of white-label/customizable IP licensing/usage web applications for creators, enterprises and consumers. These apps are available as a multi-tenant service (with many UI customization options) or for complete white-label repackaging."
      />
      <PricingSection4
        color="white"
        size="medium"
        backgroundImage="/halftone-1696560535.svg"
        backgroundImageOpacity={1}
        title="Demo applications"
        subtitle="PDS demo applications show the ways our licensing functionality can transform business processes in IP and data management across different verticals."
      />
      <NewsletterSection
        color="light"
        size="medium"
        backgroundImage=""
        backgroundImageOpacity={1}
        title="Learn more!"
        subtitle="Sign up to get in touch with us about app projects in development."
        buttonText="Subscribe"
        buttonColor="primary"
        buttonInverted={false}
        inputPlaceholder="Enter your email"
        subscribedMessage="You are now subscribed!"
      />
    </>
  );
}

export default AppsPage;
